import { PropsWithChildren, ReactElement } from 'react';
import styled from 'styled-components';

const Section = ({ children, ...props }: PropsWithChildren) => <SectionWrapper {...props}>{children}</SectionWrapper>;

const SectionTitle = ({ title, children, ...props }: PropsWithChildren<{ title: ReactElement | string }>) => {
  return (
    <SectionTitleRow {...props}>
      <Title>{title}</Title>
      {children}
    </SectionTitleRow>
  );
};
const SectionDivider = () => {
  return <Divider />;
};

Section.Title = SectionTitle;
Section.Divider = SectionDivider;

export default Section;

const SectionWrapper = styled.div`
  display: flex;
  padding: 28px 0;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`;

const SectionTitleRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0 24px;
`;

const Title = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI19SB};
    color: ${theme.color.gray700};
  `}
`;

const Divider = styled.div`
  width: 100%;
  height: 16px;

  ${({ theme }) => `
    background: ${theme.color.gray30};
    border-top: 1px solid ${theme.color.gray50};
  `};
`;
